import { CfStickyDoubleColumnProps } from "./schema";
import React from "react";
import StickyDoubleColumn, { StickyDoubleColumnProps } from "..";
import recursiveRender from "utilities/recursiveRender";

const convertCfStickyDoubleColumnProps = ({
  leftContent,
  stickyContent,
}: CfStickyDoubleColumnProps) => {
  const props: StickyDoubleColumnProps = {
    content: recursiveRender({ cfComponent: leftContent }),
    stickyContent: recursiveRender({ cfComponent: stickyContent }),
  };

  return props;
};

const CfStickyDoubleColumn = (props: CfStickyDoubleColumnProps) => (
  <StickyDoubleColumn {...convertCfStickyDoubleColumnProps(props)} />
);

export default CfStickyDoubleColumn;
